import { supabase } from '../../shared/supabase/supabaseClient';

export type PulledPurchaseOrderRow = Record<string, unknown>;
export type PulledPurchaseOrderItemRow = Record<string, unknown>;
export type PulledReceptionRow = Record<string, unknown>;
export type PulledReceptionItemRow = Record<string, unknown>;
export type PulledReturnRow = Record<string, unknown>;
export type PulledReturnItemRow = Record<string, unknown>;

export type PurchasesPullPayload = {
  purchaseOrders: PulledPurchaseOrderRow[];
  purchaseOrderItems: PulledPurchaseOrderItemRow[];
  receptions: PulledReceptionRow[];
  receptionItems: PulledReceptionItemRow[];
  returns: PulledReturnRow[];
  returnItems: PulledReturnItemRow[];
};

export async function pullBranchPurchasesRemote(
  branchId: string,
  sinceIso: string | null,
): Promise<PurchasesPullPayload> {
  const { data, error } = await supabase.schema('pos').rpc('pull_branch_purchases_since', {
    p_branch_id: branchId,
    p_since: sinceIso,
  });
  if (error) throw error;
  const raw = (data ?? {}) as Record<string, unknown>;
  return {
    purchaseOrders: Array.isArray(raw.purchase_orders) ? raw.purchase_orders as PulledPurchaseOrderRow[] : [],
    purchaseOrderItems: Array.isArray(raw.purchase_order_items) ? raw.purchase_order_items as PulledPurchaseOrderItemRow[] : [],
    receptions: Array.isArray(raw.receptions) ? raw.receptions as PulledReceptionRow[] : [],
    receptionItems: Array.isArray(raw.reception_items) ? raw.reception_items as PulledReceptionItemRow[] : [],
    returns: Array.isArray(raw.returns) ? raw.returns as PulledReturnRow[] : [],
    returnItems: Array.isArray(raw.return_items) ? raw.return_items as PulledReturnItemRow[] : [],
  };
}
